/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderAppMetadata } from './ProviderAppMetadata';
import {
    ProviderAppMetadataFromJSON,
    ProviderAppMetadataFromJSONTyped,
    ProviderAppMetadataToJSON,
} from './ProviderAppMetadata';

/**
 * 
 * @export
 * @interface CreateProviderAppRequest
 */
export interface CreateProviderAppRequest {
    /**
     * The ID used by the provider to identify the app (optional).
     * @type {string}
     * @memberof CreateProviderAppRequest
     */
    externalRef?: string;
    /**
     * The SaaS provider that this app connects to.
     * @type {string}
     * @memberof CreateProviderAppRequest
     */
    provider: string;
    /**
     * The OAuth client ID for this app.
     * @type {string}
     * @memberof CreateProviderAppRequest
     */
    clientId: string;
    /**
     * The OAuth client secret for this app.
     * @type {string}
     * @memberof CreateProviderAppRequest
     */
    clientSecret: string;
    /**
     * The OAuth scopes for this app.
     * @type {Array<string>}
     * @memberof CreateProviderAppRequest
     */
    scopes?: Array<string>;
    /**
     * 
     * @type {ProviderAppMetadata}
     * @memberof CreateProviderAppRequest
     */
    metadata?: ProviderAppMetadata;
}

/**
 * Check if a given object implements the CreateProviderAppRequest interface.
 */
export function instanceOfCreateProviderAppRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "provider" in value;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "clientSecret" in value;

    return isInstance;
}

export function CreateProviderAppRequestFromJSON(json: any): CreateProviderAppRequest {
    return CreateProviderAppRequestFromJSONTyped(json, false);
}

export function CreateProviderAppRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProviderAppRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'externalRef': !exists(json, 'externalRef') ? undefined : json['externalRef'],
        'provider': json['provider'],
        'clientId': json['clientId'],
        'clientSecret': json['clientSecret'],
        'scopes': !exists(json, 'scopes') ? undefined : json['scopes'],
        'metadata': !exists(json, 'metadata') ? undefined : ProviderAppMetadataFromJSON(json['metadata']),
    };
}

export function CreateProviderAppRequestToJSON(value?: CreateProviderAppRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'externalRef': value.externalRef,
        'provider': value.provider,
        'clientId': value.clientId,
        'clientSecret': value.clientSecret,
        'scopes': value.scopes,
        'metadata': ProviderAppMetadataToJSON(value.metadata),
    };
}

